import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FieldMapPipe } from 'src/app/pipe/fieldMap.pipe';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
 


@Component({
    selector: 'rostering-top-menu',
    templateUrl: './rostering-top-menu.html',
    styles: [`.mat-toolbar {
                min-height: 50px !important;
                height: 50px !important;
                padding:0 6px !important;
            }
            .mat-toolbar-row {
                min-height: 50px !important;
                height: 50px !important;
            }
            .filterStickey{
                position: sticky;
                top: 0;
                z-index: 999;
                background: #e6e6e6;}`
            ],
})
export class RosteringTopMenuComponent implements OnInit {

    @Input() _activeMenu: string = '';
    @Output() routeTypeEmit= new EventEmitter();
    public mappingField:any = {};
    public userRestrictionData:any={};
    public routeType = ''; 
    public moduleButtons:any=[];
    public userInfo:any={};
    public showBtns:boolean=false;
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private fieldMap: FieldMapPipe,
        private storage:StorageService,
        public api:ApiService
    ) {
        this.userInfo = this.storage.get('userInfo');
        const obj = {
        orgID: this.userInfo.orgID
        };
        this.api.org_settingsList(obj).then(async (res: any) => {
            let mail=this.userInfo.userEmail;
            let selectedUser=res.data['userInfo'].filter(e=> e.userEmail==mail);
            this.userInfo['fieldMap']=selectedUser[0]['fieldMap'];
            this.storage.setData({ userInfo: this.userInfo });
            let user = this.userInfo;
            if(user && user['fieldMap']){
                this.userRestrictionData=user['fieldMap'];
                let subModulesOfRostering=Object.keys(this.userRestrictionData['Route / Rostering'].menu1);
                for(let i=0;i<subModulesOfRostering.length;i++){
                    if(this.userRestrictionData && (this.userRestrictionData['Route / Rostering'].checked || this.userRestrictionData['Route / Rostering'].indeterminate) && this.userRestrictionData['Route / Rostering'].menu1 && this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]] && (this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].checked || this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].indeterminate)){
                        this.moduleButtons.push(subModulesOfRostering[i]);
                    }
                }
            }
            if(this.moduleButtons.length>0) this.showBtns=true;
            let actvUrl=this.router.url.split('/');
            if(actvUrl.length==4 && actvUrl[3]=='rostering'){
                this._activeMenu='Activities';
            }else if(actvUrl.length==5 && actvUrl[4]=='manage-route'){
                this._activeMenu='Manage Route';
            }else if(actvUrl.includes('create-route')){
                this._activeMenu='Create Route';
            }else if(actvUrl.includes('edit-route')){
                this._activeMenu='Edit Route';
            }
            this.urlParser(window.location.pathname);
        }).catch((err) => {
            console.log(err);
        });
    }


    ngOnInit(): void {

    }

    urlParser(pathname) {
        const pathSplit = pathname.split('/');
        //   console.log(pathSplit)
        if (pathSplit[4] && (pathSplit[4] === 'create-route' || pathSplit[4] ==='edit-route') && pathSplit[5]) {
            this.routeType = pathSplit[5];
            setTimeout(()=>{                
            this.routeTypeEmit.emit(this.routeType);
            },400);
        }

        //   this.activatedRoute.queryParams.subscribe(params => {
        //     console.log(params)
        //     // this.routeType = params['routeType'];
        //   });
    }

    pageNavigate(path, $event) {

        
        const urlPath = 'organization/transport-manager/rostering/';
        this.router.navigate([urlPath + 're-route']);
        setTimeout(()=>{
            this.router.navigate([urlPath + path]);
        },10);
        // this.router.navigate(['/heroes', { id: heroId }]);
    }

    fieldMapValue(defaultValue:string,key:string){
     return this.fieldMap.transform(defaultValue,this.mappingField,['route/rostering','menuButtons',key,'name'])
    }

}